/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as YourVenuesRouteImport } from './routes/your-venues'
import { Route as YourPeopleRouteImport } from './routes/your-people'
import { Route as YouRouteImport } from './routes/you'
import { Route as StumblingRouteImport } from './routes/stumbling'
import { Route as SquadRouteImport } from './routes/squad'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IndexRouteImport } from './routes/index'
import { Route as YourPeopleIndexRouteImport } from './routes/your-people/index'
import { Route as YourPeopleAddRouteImport } from './routes/your-people/add'
import { Route as YourPeopleFriendIdRouteImport } from './routes/your-people/$friendId'
import { Route as SquadSetupRouteImport } from './routes/squad/setup'
import { Route as NightIdRouteImport } from './routes/night/$id'
import { Route as NightIdIndexRouteImport } from './routes/night/$id/index'
import { Route as SquadBattleIdRouteImport } from './routes/squad/battle/$id'
import { Route as NightIdVenueRouteImport } from './routes/night/$id/venue'
import { Route as NightIdRecapRouteImport } from './routes/night/$id/recap'
import { Route as SquadBattleIdIndexRouteImport } from './routes/squad/battle/$id/index'
import { Route as SquadBattleIdClaimedVenueIdRouteImport } from './routes/squad/battle/$id/claimed/$venueId'

const YourVenuesRoute = YourVenuesRouteImport.update({
  id: '/your-venues',
  path: '/your-venues',
  getParentRoute: () => rootRouteImport,
} as any)
const YourPeopleRoute = YourPeopleRouteImport.update({
  id: '/your-people',
  path: '/your-people',
  getParentRoute: () => rootRouteImport,
} as any)
const YouRoute = YouRouteImport.update({
  id: '/you',
  path: '/you',
  getParentRoute: () => rootRouteImport,
} as any)
const StumblingRoute = StumblingRouteImport.update({
  id: '/stumbling',
  path: '/stumbling',
  getParentRoute: () => rootRouteImport,
} as any)
const SquadRoute = SquadRouteImport.update({
  id: '/squad',
  path: '/squad',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const YourPeopleIndexRoute = YourPeopleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => YourPeopleRoute,
} as any)
const YourPeopleAddRoute = YourPeopleAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => YourPeopleRoute,
} as any)
const YourPeopleFriendIdRoute = YourPeopleFriendIdRouteImport.update({
  id: '/$friendId',
  path: '/$friendId',
  getParentRoute: () => YourPeopleRoute,
} as any)
const SquadSetupRoute = SquadSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => SquadRoute,
} as any)
const NightIdRoute = NightIdRouteImport.update({
  id: '/night/$id',
  path: '/night/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const NightIdIndexRoute = NightIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NightIdRoute,
} as any)
const SquadBattleIdRoute = SquadBattleIdRouteImport.update({
  id: '/battle/$id',
  path: '/battle/$id',
  getParentRoute: () => SquadRoute,
} as any)
const NightIdVenueRoute = NightIdVenueRouteImport.update({
  id: '/venue',
  path: '/venue',
  getParentRoute: () => NightIdRoute,
} as any)
const NightIdRecapRoute = NightIdRecapRouteImport.update({
  id: '/recap',
  path: '/recap',
  getParentRoute: () => NightIdRoute,
} as any)
const SquadBattleIdIndexRoute = SquadBattleIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SquadBattleIdRoute,
} as any)
const SquadBattleIdClaimedVenueIdRoute =
  SquadBattleIdClaimedVenueIdRouteImport.update({
    id: '/claimed/$venueId',
    path: '/claimed/$venueId',
    getParentRoute: () => SquadBattleIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/squad': typeof SquadRouteWithChildren
  '/stumbling': typeof StumblingRoute
  '/you': typeof YouRoute
  '/your-people': typeof YourPeopleRouteWithChildren
  '/your-venues': typeof YourVenuesRoute
  '/night/$id': typeof NightIdRouteWithChildren
  '/squad/setup': typeof SquadSetupRoute
  '/your-people/$friendId': typeof YourPeopleFriendIdRoute
  '/your-people/add': typeof YourPeopleAddRoute
  '/your-people/': typeof YourPeopleIndexRoute
  '/night/$id/recap': typeof NightIdRecapRoute
  '/night/$id/venue': typeof NightIdVenueRoute
  '/squad/battle/$id': typeof SquadBattleIdRouteWithChildren
  '/night/$id/': typeof NightIdIndexRoute
  '/squad/battle/$id/': typeof SquadBattleIdIndexRoute
  '/squad/battle/$id/claimed/$venueId': typeof SquadBattleIdClaimedVenueIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/squad': typeof SquadRouteWithChildren
  '/stumbling': typeof StumblingRoute
  '/you': typeof YouRoute
  '/your-venues': typeof YourVenuesRoute
  '/squad/setup': typeof SquadSetupRoute
  '/your-people/$friendId': typeof YourPeopleFriendIdRoute
  '/your-people/add': typeof YourPeopleAddRoute
  '/your-people': typeof YourPeopleIndexRoute
  '/night/$id/recap': typeof NightIdRecapRoute
  '/night/$id/venue': typeof NightIdVenueRoute
  '/night/$id': typeof NightIdIndexRoute
  '/squad/battle/$id': typeof SquadBattleIdIndexRoute
  '/squad/battle/$id/claimed/$venueId': typeof SquadBattleIdClaimedVenueIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/squad': typeof SquadRouteWithChildren
  '/stumbling': typeof StumblingRoute
  '/you': typeof YouRoute
  '/your-people': typeof YourPeopleRouteWithChildren
  '/your-venues': typeof YourVenuesRoute
  '/night/$id': typeof NightIdRouteWithChildren
  '/squad/setup': typeof SquadSetupRoute
  '/your-people/$friendId': typeof YourPeopleFriendIdRoute
  '/your-people/add': typeof YourPeopleAddRoute
  '/your-people/': typeof YourPeopleIndexRoute
  '/night/$id/recap': typeof NightIdRecapRoute
  '/night/$id/venue': typeof NightIdVenueRoute
  '/squad/battle/$id': typeof SquadBattleIdRouteWithChildren
  '/night/$id/': typeof NightIdIndexRoute
  '/squad/battle/$id/': typeof SquadBattleIdIndexRoute
  '/squad/battle/$id/claimed/$venueId': typeof SquadBattleIdClaimedVenueIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/login'
    | '/onboarding'
    | '/squad'
    | '/stumbling'
    | '/you'
    | '/your-people'
    | '/your-venues'
    | '/night/$id'
    | '/squad/setup'
    | '/your-people/$friendId'
    | '/your-people/add'
    | '/your-people/'
    | '/night/$id/recap'
    | '/night/$id/venue'
    | '/squad/battle/$id'
    | '/night/$id/'
    | '/squad/battle/$id/'
    | '/squad/battle/$id/claimed/$venueId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/login'
    | '/onboarding'
    | '/squad'
    | '/stumbling'
    | '/you'
    | '/your-venues'
    | '/squad/setup'
    | '/your-people/$friendId'
    | '/your-people/add'
    | '/your-people'
    | '/night/$id/recap'
    | '/night/$id/venue'
    | '/night/$id'
    | '/squad/battle/$id'
    | '/squad/battle/$id/claimed/$venueId'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/login'
    | '/onboarding'
    | '/squad'
    | '/stumbling'
    | '/you'
    | '/your-people'
    | '/your-venues'
    | '/night/$id'
    | '/squad/setup'
    | '/your-people/$friendId'
    | '/your-people/add'
    | '/your-people/'
    | '/night/$id/recap'
    | '/night/$id/venue'
    | '/squad/battle/$id'
    | '/night/$id/'
    | '/squad/battle/$id/'
    | '/squad/battle/$id/claimed/$venueId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRoute: typeof HistoryRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  SquadRoute: typeof SquadRouteWithChildren
  StumblingRoute: typeof StumblingRoute
  YouRoute: typeof YouRoute
  YourPeopleRoute: typeof YourPeopleRouteWithChildren
  YourVenuesRoute: typeof YourVenuesRoute
  NightIdRoute: typeof NightIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/your-venues': {
      id: '/your-venues'
      path: '/your-venues'
      fullPath: '/your-venues'
      preLoaderRoute: typeof YourVenuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-people': {
      id: '/your-people'
      path: '/your-people'
      fullPath: '/your-people'
      preLoaderRoute: typeof YourPeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/you': {
      id: '/you'
      path: '/you'
      fullPath: '/you'
      preLoaderRoute: typeof YouRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stumbling': {
      id: '/stumbling'
      path: '/stumbling'
      fullPath: '/stumbling'
      preLoaderRoute: typeof StumblingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/squad': {
      id: '/squad'
      path: '/squad'
      fullPath: '/squad'
      preLoaderRoute: typeof SquadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/your-people/': {
      id: '/your-people/'
      path: '/'
      fullPath: '/your-people/'
      preLoaderRoute: typeof YourPeopleIndexRouteImport
      parentRoute: typeof YourPeopleRoute
    }
    '/your-people/add': {
      id: '/your-people/add'
      path: '/add'
      fullPath: '/your-people/add'
      preLoaderRoute: typeof YourPeopleAddRouteImport
      parentRoute: typeof YourPeopleRoute
    }
    '/your-people/$friendId': {
      id: '/your-people/$friendId'
      path: '/$friendId'
      fullPath: '/your-people/$friendId'
      preLoaderRoute: typeof YourPeopleFriendIdRouteImport
      parentRoute: typeof YourPeopleRoute
    }
    '/squad/setup': {
      id: '/squad/setup'
      path: '/setup'
      fullPath: '/squad/setup'
      preLoaderRoute: typeof SquadSetupRouteImport
      parentRoute: typeof SquadRoute
    }
    '/night/$id': {
      id: '/night/$id'
      path: '/night/$id'
      fullPath: '/night/$id'
      preLoaderRoute: typeof NightIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/night/$id/': {
      id: '/night/$id/'
      path: '/'
      fullPath: '/night/$id/'
      preLoaderRoute: typeof NightIdIndexRouteImport
      parentRoute: typeof NightIdRoute
    }
    '/squad/battle/$id': {
      id: '/squad/battle/$id'
      path: '/battle/$id'
      fullPath: '/squad/battle/$id'
      preLoaderRoute: typeof SquadBattleIdRouteImport
      parentRoute: typeof SquadRoute
    }
    '/night/$id/venue': {
      id: '/night/$id/venue'
      path: '/venue'
      fullPath: '/night/$id/venue'
      preLoaderRoute: typeof NightIdVenueRouteImport
      parentRoute: typeof NightIdRoute
    }
    '/night/$id/recap': {
      id: '/night/$id/recap'
      path: '/recap'
      fullPath: '/night/$id/recap'
      preLoaderRoute: typeof NightIdRecapRouteImport
      parentRoute: typeof NightIdRoute
    }
    '/squad/battle/$id/': {
      id: '/squad/battle/$id/'
      path: '/'
      fullPath: '/squad/battle/$id/'
      preLoaderRoute: typeof SquadBattleIdIndexRouteImport
      parentRoute: typeof SquadBattleIdRoute
    }
    '/squad/battle/$id/claimed/$venueId': {
      id: '/squad/battle/$id/claimed/$venueId'
      path: '/claimed/$venueId'
      fullPath: '/squad/battle/$id/claimed/$venueId'
      preLoaderRoute: typeof SquadBattleIdClaimedVenueIdRouteImport
      parentRoute: typeof SquadBattleIdRoute
    }
  }
}

interface SquadBattleIdRouteChildren {
  SquadBattleIdIndexRoute: typeof SquadBattleIdIndexRoute
  SquadBattleIdClaimedVenueIdRoute: typeof SquadBattleIdClaimedVenueIdRoute
}

const SquadBattleIdRouteChildren: SquadBattleIdRouteChildren = {
  SquadBattleIdIndexRoute: SquadBattleIdIndexRoute,
  SquadBattleIdClaimedVenueIdRoute: SquadBattleIdClaimedVenueIdRoute,
}

const SquadBattleIdRouteWithChildren = SquadBattleIdRoute._addFileChildren(
  SquadBattleIdRouteChildren,
)

interface SquadRouteChildren {
  SquadSetupRoute: typeof SquadSetupRoute
  SquadBattleIdRoute: typeof SquadBattleIdRouteWithChildren
}

const SquadRouteChildren: SquadRouteChildren = {
  SquadSetupRoute: SquadSetupRoute,
  SquadBattleIdRoute: SquadBattleIdRouteWithChildren,
}

const SquadRouteWithChildren = SquadRoute._addFileChildren(SquadRouteChildren)

interface YourPeopleRouteChildren {
  YourPeopleFriendIdRoute: typeof YourPeopleFriendIdRoute
  YourPeopleAddRoute: typeof YourPeopleAddRoute
  YourPeopleIndexRoute: typeof YourPeopleIndexRoute
}

const YourPeopleRouteChildren: YourPeopleRouteChildren = {
  YourPeopleFriendIdRoute: YourPeopleFriendIdRoute,
  YourPeopleAddRoute: YourPeopleAddRoute,
  YourPeopleIndexRoute: YourPeopleIndexRoute,
}

const YourPeopleRouteWithChildren = YourPeopleRoute._addFileChildren(
  YourPeopleRouteChildren,
)

interface NightIdRouteChildren {
  NightIdRecapRoute: typeof NightIdRecapRoute
  NightIdVenueRoute: typeof NightIdVenueRoute
  NightIdIndexRoute: typeof NightIdIndexRoute
}

const NightIdRouteChildren: NightIdRouteChildren = {
  NightIdRecapRoute: NightIdRecapRoute,
  NightIdVenueRoute: NightIdVenueRoute,
  NightIdIndexRoute: NightIdIndexRoute,
}

const NightIdRouteWithChildren =
  NightIdRoute._addFileChildren(NightIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRoute: HistoryRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  SquadRoute: SquadRouteWithChildren,
  StumblingRoute: StumblingRoute,
  YouRoute: YouRoute,
  YourPeopleRoute: YourPeopleRouteWithChildren,
  YourVenuesRoute: YourVenuesRoute,
  NightIdRoute: NightIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
